export default __webpack_public_path__ + "static/media/samuel.4ad61a69.pdf";